import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { accessApi } from "../../services/accessApi";

export default function ITMailAccountsPage() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await accessApi.getMailAccounts();
      setRows(res?.data?.data || []);
    } catch (err) {
      console.error("ITMailAccountsPage load error:", err);
      setError(err?.response?.data?.message || err.message || "Failed to load mail accounts.");
    } finally {
      setLoading(false);
    }
  };

  const filteredRows = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return rows;

    return rows.filter((row) =>
      [row.email, row.display_name, row.imap_host, row.smtp_host]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(needle)
    );
  }, [rows, q]);

  if (loading) return <div className="p-6 text-black dark:text-white">Loading mail accounts...</div>;
  if (error) return <div className="p-6 text-red-600 dark:text-red-400">{error}</div>;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-black dark:text-white">Mail Accounts</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Manage mailbox accounts and assigned users.
        </p>
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 p-4">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search mail accounts..."
          className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
        />
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[1000px]">
            <thead className="bg-gray-50 dark:bg-neutral-800">
              <tr className="border-b border-gray-200 dark:border-neutral-700">
                <th className="text-left p-3">Email</th>
                <th className="text-left p-3">Display Name</th>
                <th className="text-left p-3">Shared</th>
                <th className="text-left p-3">Status</th>
                <th className="text-left p-3">Assigned Users</th>
                <th className="text-left p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-100 dark:border-neutral-800 hover:bg-gray-50 dark:hover:bg-neutral-800/60"
                >
                  <td className="p-3 text-black dark:text-white font-medium">{row.email}</td>
                  <td className="p-3 text-black dark:text-white">{row.display_name || "-"}</td>
                  <td className="p-3 text-black dark:text-white">{Number(row.is_shared) === 1 ? "Yes" : "No"}</td>
                  <td className="p-3 text-black dark:text-white">{Number(row.is_active) === 1 ? "Active" : "Inactive"}</td>
                  <td className="p-3 text-black dark:text-white">{row.assigned_users_count}</td>
                  <td className="p-3">
                    <button
                      onClick={() => navigate(`/it/mail/accounts/${row.id}`)}
                      className="px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 text-black dark:text-white"
                    >
                      Open Access
                    </button>
                  </td>
                </tr>
              ))}

              {filteredRows.length === 0 && (
                <tr>
                  <td colSpan={6} className="p-8 text-center text-gray-500 dark:text-gray-400">
                    No mail accounts found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}